import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ca522d44&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ca522d44&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=ca522d44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca522d44",
  null
  
)

export default component.exports